import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store'
import globalService from './services/globalService';
import vuetify from './plugins/vuetify';
import VueGeolocation from 'vue-browser-geolocation';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import baseComponent from './views/_baseComponent'
const moment = require('moment');
require('moment/locale/es');

Vue.config.productionTip = false

globalService.getConfig().then(config => {
  const { commit } = store;
  commit('global/SET_CONFIG', config);

  //Definimos que estamos estableciendo conexión
  commit("global/SET_CONECTANDO", true);
  globalService.getVersion().then(version => {
    commit('global/SET_VERSION', version);
    commit("global/SET_CONEXION", true);
  }).catch(e => {
    commit("global/SET_CONEXION", false);
    setTimeout(() => {
      router.push("/error-conexion");
    }, 100);
  });



  Vue.use(require('vue-moment'), { moment });
  Vue.use(VueGeolocation);
  Vue.mixin(baseComponent);

  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')

});